import React, { useState, useEffect, useRef } from "react";
import Draggable from "react-draggable";
import { Box, ClickAwayListener, Paper, Typography } from "@mui/material";
import LayerToolbar from "./LayerToolbar";
import { useData } from "../hooks/useData";

const DraggableLayersPopover = ({ canvas, saveHistory, onClose }) => {
  const { setSelectedObject } = useData();
  const [isDisabled, setIsDisabled] = useState(true);
  const nodeRef = useRef(null); // Ref for the Paper component

  useEffect(() => {
    if (!canvas) return;

    const updateDisabledState = () => {
      const objects = canvas.getObjects();
      setIsDisabled(objects.length < 2);
      if (objects.length < 2) {
        onClose(); // Close popover if not enough objects
      }
    };

    canvas.on("object:added", updateDisabledState);
    canvas.on("object:removed", updateDisabledState);
    canvas.on("selection:updated", updateDisabledState);
    canvas.on("selection:cleared", updateDisabledState);

    // Initial check
    updateDisabledState();

    return () => {
      canvas.off("object:added", updateDisabledState);
      canvas.off("object:removed", updateDisabledState);
      canvas.off("selection:updated", updateDisabledState);
      canvas.off("selection:cleared", updateDisabledState);
    };
  }, [canvas, onClose]);

  const handleClickAway = () => {
    if (!isDisabled) {
      onClose();
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Draggable handle=".draggable-handle" nodeRef={nodeRef}>
        <Paper
          ref={nodeRef} // Attach ref to Paper
          elevation={3}
          sx={{
            position: "absolute",
            top: "100px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1400,
            backgroundColor: "white",
            borderRadius: "4px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
            minWidth: "200px",
            maxWidth: "300px",
            overflow: "hidden",
          }}
        >
          <Box
            className="draggable-handle"
            sx={{
              backgroundColor: "#f5f5f5",
              padding: "8px",
              cursor: "move",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Layers
            </Typography>
          </Box>
          <Box sx={{ padding: "8px" }}>
            <LayerToolbar
              canvas={canvas}
              saveHistory={saveHistory}
              setSelectedObject={setSelectedObject}
            />
          </Box>
        </Paper>
      </Draggable>
    </ClickAwayListener>
  );
};

export default DraggableLayersPopover;
